var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 149,
    viewBox: "0 0 176 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.272 125.729c26.245-12.929 39.367-28.12 39.367-45.573-11.186-1.293-20.436-5.871-27.75-13.736C4.574 58.555.917 49.45.917 39.108c0-10.989 3.55-20.254 10.649-27.796C18.665 3.771 27.592 0 38.349 0c12.047 0 22.48 4.902 31.3 14.706 8.82 9.804 13.23 21.709 13.23 35.715 0 42.017-23.448 74.877-70.345 98.579L.272 125.729zm92.62 0c26.461-12.929 39.691-28.12 39.691-45.573-11.402-1.293-20.76-5.871-28.074-13.736S93.538 49.45 93.538 39.108c0-10.989 3.603-20.254 10.81-27.796C111.554 3.771 120.536 0 131.292 0c12.047 0 22.427 4.902 31.139 14.706 8.713 9.804 13.069 21.709 13.069 35.715 0 42.017-23.341 74.877-70.023 98.579l-12.585-23.271z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/testimonials/quotes-788bbaa9.svg";
export { SvgQuotes as ReactComponent };